import React from "react";

/**
 * ZT Global Logo — official ZT icon (cropped from ZT Corporate tertiary logo)
 * paired with a custom "ZT GLOBAL · CAPITAL · ADVISORY" wordmark.
 *
 * `tone`    — "light" renders ink on transparent (navy icon stays navy on light bg)
 *             "dark"  renders the icon tinted to ivory for dark backgrounds
 * `compact` — hides the wordmark (icon-only).
 */
const Logo = ({ tone = "dark", compact = false, className = "" }) => {
  const isLight = tone === "light";
  const inkClass = isLight ? "text-navy" : "text-white";
  const subtleClass = isLight ? "text-navy/55" : "text-white/60";

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="zt-logo">
      <img
        src="/images/zt-logo-icon.png"
        alt="ZT Global"
        className="h-14 w-auto shrink-0"
        style={{
          filter: isLight
            ? "none"
            : "brightness(0) saturate(100%) invert(99%) sepia(7%) saturate(236%) hue-rotate(2deg) brightness(100%) contrast(98%)",
        }}
      />
      {!compact && (
        <div className="flex flex-col leading-none select-none">
          <span className={`font-sans text-[22px] md:text-[24px] tracking-[0.30em] uppercase font-bold ${inkClass}`} style={{ lineHeight: 1 }}>
            ZT&nbsp;Global
          </span>
          <span className={`mt-2.5 font-sans text-[10px] tracking-[0.32em] uppercase font-medium ${subtleClass}`} style={{ lineHeight: 1 }}>
            Capital · Advisory
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
